module.exports = __webpack_public_path__ + "img/foto18.b054c411.jpg";